import React, { FC } from 'react';
import styles from './styles';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import HeaderOne from '../HeaderOne';
import View from '../../../components/styled/View';
import LinearGradientButton from '../LinearGradientButton';
import {
  ARTIST_BODY_TEXT,
  FAN_BODY_TEXT,
  FINISH_SETTING_UP,
  PROFILE_BUTTON_TEXT,
  SESSION_BUTTON_TEXT,
  SESSION_BODY_TEXT,
  TITLE,
  VERIFICATION_BUTTON_TEXT,
  WELCOME_BACK_HEADER,
} from './constants';

export enum UserErrorCodes {
  ARTIST_DASHBOARD_ERROR = 'ARTIST_DASHBOARD_ERROR',
  ARTIST_PROFILE_ERROR = 'ARTIST_PROFILE_ERROR',
  FAN_LISTEN_ERROR = 'FAN_LISTEN_ERROR',
  FAN_PROFILE_ERROR = 'FAN_PROFILE_ERROR',
  SESSION_ERROR = 'SESSION_ERROR',
  NONE = 'NONE',
  VERIFICATION_ERROR = 'VERIFICATION_ERROR',
}

export type UserErrorProps = {
  errorType: keyof typeof UserErrorCodes;
  handleUserErrorOverride?: () => void;
  navigation: any;
};

export const UserError: FC<UserErrorProps> = (props) => {
  const { errorType, handleUserErrorOverride, navigation } = props;

  const onButtonPress = () => {
    handleUserErrorOverride && handleUserErrorOverride();
  };

  const goToFanCreateProfileFromListen = () => {
    navigation.navigate('Account', {
      screen: 'FanCreateProfile',
    });
  };

  const goToFanCreateProfileFromProfile = () => {
    navigation.navigate('FanCreateProfile');
  };

  const goToArtistCreateProfileFromDashboard = () => {
    navigation.navigate('Profile', { screen: 'ArtistCreateProfile' });
  };

  const goToArtistCreateProfileFromProfile = () => {
    navigation.navigate('ArtistCreateProfile');
  };

  const data = {
    ARTIST_DASHBOARD_ERROR: {
      title: TITLE,
      bodyText: ARTIST_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: PROFILE_BUTTON_TEXT,
      onPress: goToArtistCreateProfileFromDashboard,
    },
    ARTIST_PROFILE_ERROR: {
      title: TITLE,
      bodyText: ARTIST_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: PROFILE_BUTTON_TEXT,
      onPress: goToArtistCreateProfileFromProfile,
    },
    FAN_LISTEN_ERROR: {
      title: TITLE,
      bodyText: FAN_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: PROFILE_BUTTON_TEXT,
      onPress: goToFanCreateProfileFromListen,
    },
    FAN_PROFILE_ERROR: {
      title: TITLE,
      bodyText: FAN_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: PROFILE_BUTTON_TEXT,
      onPress: goToFanCreateProfileFromProfile,
    },
    SESSION_ERROR: {
      title: TITLE,
      bodyText: SESSION_BODY_TEXT,
      button: LinearGradientButton,
      buttonText: SESSION_BUTTON_TEXT,
      onPress: onButtonPress,
    },
    VERIFICATION_ERROR: {
      title: WELCOME_BACK_HEADER,
      bodyText: FINISH_SETTING_UP,
      button: LinearGradientButton,
      buttonText: VERIFICATION_BUTTON_TEXT,
      onPress: onButtonPress,
    },
  };

  const { bodyText = '', title, button: Button, buttonText, onPress } =
    data[errorType] || {};

  return (
    <View style={styles.container}>
      <HeaderOne style={styles.header} title={title} />
      <GalanoGrotesqueText style={styles.platformText}>
        {bodyText}
      </GalanoGrotesqueText>
      <View style={styles.buttonContainer}>
        <Button
          textStyle={styles.editLinkText}
          title={buttonText}
          onPress={onPress}
        />
      </View>
    </View>
  );
};

export default UserError;
